<div
  class="avatar"
  [ngStyle]="{ width: size + 'px', height: size + 'px', background: hasImage ? 'transparent' : bgColor }"
  [class.has-image]="hasImage"
  [attr.title]="name || email"
>
  @if (hasImage) {
    <img [src]="src" [alt]="name || email" />
  }
  @if (!hasImage) {
    <span>{{ initials }}</span>
  }
</div>
